var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStaffBlue24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-staff-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 219",
    d: "M2.50004 19.5L2.5 4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5001C20.6046 2.5 21.5001 3.39543 21.5001 4.5L21.5001 19.5C21.5001 20.6046 20.6047 21.5 19.5001 21.5H4.50004C3.39547 21.5 2.50004 20.6046 2.50004 19.5Z",
    stroke: "#286BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 63",
    d: "M16.5 10C16.5 12.4853 14.4853 14.5 12 14.5C9.51472 14.5 7.5 12.4853 7.5 10C7.5 7.51472 9.51472 5.5 12 5.5C14.4853 5.5 16.5 7.51472 16.5 10Z",
    stroke: "#286BB7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 65",
    d: "M4.51562 21.5C4.77292 17.591 8.0251 14.5 11.9992 14.5C15.9733 14.5 19.2255 17.591 19.4828 21.5",
    stroke: "#286BB7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaffBlue24);
export default __webpack_public_path__ + "static/media/icon-staff-blue-24.61b0fbffbc26fcecd51ea90a4a94f3d2.svg";
export { ForwardRef as ReactComponent };